export default "__VITE_ASSET__BZ$eadWg__"